import { FC, ReactNode } from 'react';

import { cn } from '../utils/class-names.util.ts';

interface Props {
  children: ReactNode;
  stickyTopComponent?: ReactNode;
  stickyBottomComponent?: ReactNode;
  className?: string;
}

export const CommonScreenContainer: FC<Props> = ({
  children,
  stickyTopComponent,
  stickyBottomComponent,
  className,
}) => {
  const containerClasses = cn('flex flex-1 flex-col overflow-hidden', className);

  return (
    <div className="bg-background relative flex min-h-screen w-full flex-col">
      <div className="z-100 sticky top-0">{stickyTopComponent}</div>

      <div className={containerClasses}>{children}</div>

      {stickyBottomComponent && <div className="z-100 sticky bottom-0">{stickyBottomComponent}</div>}
    </div>
  );
};
